import appService from '../../server/app.service'
import _ from 'lodash'


const state = {
    scans: [],
    projects: []
}

const getters = {
    scans: state => state.scans,
    projects: state => state.projects
}

const actions = {

    loadDashboardData (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadDashboardData', { data: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    read (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                context.commit('read', { success: data.success, id: data.id  })
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)
        })
    },

    importLibrary (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                context.commit('importLibrary', { success: data.success, id: data.id  })
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)
        })
    },

}

const mutations = {

    loadDashboardData (state, data) {
        state.scans = data.data.scans
        state.projects = data.data.projects
    },

    read (state, data) {
        let index = _.findIndex(state.scans, function(o) { return o.id === data.id; });
        state.scans.splice(index, 1)
    },

    importLibrary (state, data) {
        let index = _.findIndex(state.scans, function(o) { return o.id === data.id; });
        state.scans.splice(index, 1)
    },

    truncateScans(state) {
        state.scans = [];
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
